import { useEffect, useState } from "react";
import { DEFAULT_MARKETPLACE_RANGE } from "../../../../constants/automapMarketplaceAnalyticsConstants";
import { fetchDemandAnalytics } from "../../../../services/automapMarketplaceAnalyticsApi";
import { AnalyticsBreakdownTable, AnalyticsSummaryGrid } from "../AdminAnalyticsShared";
import { MarketplaceAnalyticsShell } from "./AdminMarketplaceAnalyticsShared";

export default function AdminDemandAnalyticsPage() {
  const [range, setRange] = useState(DEFAULT_MARKETPLACE_RANGE);
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    fetchDemandAnalytics(range)
      .then(setPayload)
      .catch((err) => setError(err.message || "Error al cargar analytics."))
      .finally(() => setLoading(false));
  }, [range]);

  const totals = payload?.totals;

  return (
    <MarketplaceAnalyticsShell
      active="demand"
      title="Analytics de demanda"
      description="Sesiones, búsquedas, engagement y conversión de compradores."
      range={range}
      onRangeChange={setRange}
      viewEvent="demand_analytics_viewed"
    >
      {loading ? <p className="dealer-state-box">Cargando…</p> : null}
      {error ? <p className="dealer-state-box">{error}</p> : null}
      {!loading && !error && totals ? (
        <>
          <AnalyticsSummaryGrid
            items={[
              { label: "Sesiones", value: totals.sessions },
              { label: "Visitantes únicos", value: totals.uniqueVisitors },
              { label: "Búsquedas", value: totals.searches },
              { label: "Vistas detalle", value: totals.vehicleDetailViews },
              { label: "Perfil dealer", value: totals.dealerProfileViews },
              { label: "WhatsApp", value: totals.whatsappClicks },
              { label: "Leads", value: totals.leads },
              { label: "Calificados", value: totals.qualifiedLeads },
            ]}
          />
          <div className="admin-analytics-grid">
            <AnalyticsBreakdownTable title="Top ciudades búsqueda" rows={payload.topSearchCities} keyLabel="Ciudad" />
            <AnalyticsBreakdownTable title="Top marcas" rows={payload.topMakes} keyLabel="Marca" />
            <AnalyticsBreakdownTable title="Top filtros" rows={payload.topFilters} keyLabel="Filtro" />
            <AnalyticsBreakdownTable title="Sin resultados" rows={payload.noResultQueries} keyLabel="Consulta" />
            <AnalyticsBreakdownTable title="Top listings vistos" rows={payload.topViewedListings} keyLabel="Listing" />
            <AnalyticsBreakdownTable title="Top contactados" rows={payload.topContactedListings} keyLabel="Listing" />
            <AnalyticsBreakdownTable title="Demanda por ciudad" rows={payload.byCity} keyLabel="Ciudad" />
            <AnalyticsBreakdownTable title="Por carrocería" rows={payload.byBodyType} keyLabel="Tipo" />
          </div>
        </>
      ) : null}
    </MarketplaceAnalyticsShell>
  );
}
